import { useQuery } from '@tanstack/react-query';
import { dashboardApi } from '../api/endpoints';
import type { SystemStatus } from '../types';

/**
 * System status (mode, kill switch, exchange) is not pushed via WebSocket.
 * Poll at 60s to reduce load. refetchOnMount: false avoids duplicate fetches
 * when React StrictMode double-mounts in dev.
 */
export function useSystemStatus() {
  return useQuery<SystemStatus>({
    queryKey: ['dashboard', 'status'],
    queryFn: dashboardApi.getSystemStatus,
    staleTime: 60000,
    refetchInterval: 60000,
    refetchOnMount: false,
  });
}
